import React, { useEffect } from "react";
import Analytics from "../Analytics/Analytics";
import HumanOverallReport from "../HumanOverallReport/HumanOverallReport";
import { getBodyPartExerciseStatsByUserId } from "../../services/DashboardServices";
import { useParams } from "react-router-dom";

const ProgressAndAnalysis = () => {
  const [boyPartsReport, setBoyPartsReport] = React.useState([]);
  const { userId } = useParams();
  useEffect(() => {
    getBodyPartExerciseStatsByUserId(userId).then((res) => {
      setBoyPartsReport(res.data.latest_exercise_stats);
    });
  }, [userId]);
  return (
    <div>
      {/* <div className="mb-4 text-black text-lg font-semibold">Progress</div>
      <Analytics /> */}
      <div className="rounded-[20px] bg-[#fff] px-5 py-7 mb-9">
        <div className="text-[#000] text-[18px] font-semibold mb-6">
          Latest Assessment Summary
        </div>
        <HumanOverallReport data={boyPartsReport} />
      </div>
      <div className="mb-4 text-black text-lg font-semibold">Progress</div>
      <Analytics />
    </div>
  );
};

export default ProgressAndAnalysis;
